import React, {useState, useEffect} from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import {FormattedMessage, injectIntl} from "react-intl";

import TextField from "@mui/material/TextField";
import IconButton from "@mui/material/IconButton";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
import AddCircleIcon from "@mui/icons-material/AddCircle";

import {featureInterface} from "../../../../../interfaces/featureInterface";
import {addToCart, changeCartItemQuantity} from "../../../../../actions/actionFunctions";
import {setWizardSelectedValues} from "../../../../../actions/wizardFunctions";
import {getCartItemObject} from "../../../../../misc/helpers";
import {shouldUseLixilAvailableQty} from "../../lookFunctions2";


const LookWizardSectionListFeatureQuantity = (props) => {

  const {lookFeature, qtActiveCategory, cartItems, changeCartItemQuantity, intl, addToCart, fabricatorSettings} = props;

  const cartItem = cartItems.find(cItem => cItem.keepOnLookUpdate && cItem.cartFeature.dbFeature.id === lookFeature.dbFeature.id);

  const useLixilQuantity = shouldUseLixilAvailableQty(fabricatorSettings, cartItem ? cartItem.cartFeature : null);

  const [quantity, setQuantity] = useState(cartItem ? cartItem.quantity : 0);
  const MAX = cartItem && cartItem.cartFeature && cartItem.cartFeature.dbFeature.lixilAvailableQty > 0
    ? cartItem.cartFeature.dbFeature.lixilAvailableQty
    : 99999;
  const MIN = 0;

  const allowDecimals = false;

  const updateQuantity = (quan) => {
    setQuantity(quan);
  };

  useEffect(() => {
    if (cartItem && cartItem.cartFeature) {
      updateQuantity(cartItem.quantity || 0);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lookFeature]); // (remove value if cart item was deleted)

  // const handleInputChange = (e, fromButton = "") => {
  const handleInputChange = (e) => {

    let value = "" + e.target.value;

    if (value.includes(".")) {
      if (!allowDecimals) {
        return false
      }
      if (value.split(".")[1].length > 2) {
        value = +value.substring(0, value.length - 1); //round to 2 decimals
      }
    }

    value = parseInt(value) || 0;

    if (value <= MAX) {
      value = value < MIN ? MIN : value;
    } else if (value !== MAX) {
      value = MAX
    }

    // const featureLabel = Analytics.getSkuForAnalytics(cartItem.cartFeature);
    // const analyticsAdjust = fromButton ? fromButton + "-" + value : "input-" + value;
    // Analytics.sendClickEvent(`${LOOK_JOURNEY_ANALYTIC_EVENTS.lookListCartItemQuantityChange + featureLabel}-${analyticsAdjust}`);

    updateQuantity(value);
    if (cartItem) {
      changeCartItemQuantity(cartItem, value);
    } else if (value) {
      let newCartItem = getCartItemObject(lookFeature, value, qtActiveCategory);
      newCartItem.keepOnLookUpdate = true;
      addToCart([newCartItem])
    }
  };

  const handleOnKeyDown = (event) => {
    if (event.key==='.' && !allowDecimals) {
      event.preventDefault();
      return false
    }
  };

  return (
    <div className="ll-quantity ll-quantity--no-text">
      <div className="ll-quantity__actions">
        {useLixilQuantity && (quantity === MAX) ? (
          <span className="lm-stock lm-stock--red ll-quantity__max-stock">
            <FormattedMessage values={{quantity: cartItem.cartFeature.dbFeature.lixilAvailableQty}} id="look.list.feature.maxStock"/>
          </span>
        ) : null}
        <IconButton aria-label={intl.formatMessage({id:"look.list.header.printButton"})}
                    onClick={() => {
                      handleInputChange({target: {value: quantity - 1}}, "minus")
                    }}
                    className="look-icon look-icon--small look-icon--gray8">
          <RemoveCircleIcon />
        </IconButton>
        <TextField className={"ll-quantity__input" + (quantity === MAX ? " ll-quantity__input--red" : "")}
                   label=""
                   variant="outlined"
                   size="small"
                   type="number"
                   value={quantity}
                   pattern="^\d+(?:\.\d{1,2})?$"
                   onKeyDown={handleOnKeyDown}
                   onChange={handleInputChange}/>
        <IconButton aria-label={intl.formatMessage({id:"look.list.header.printButton"})}
                    disabled={quantity === MAX}
                    onClick={() => {
                      handleInputChange({target: {value: quantity + 1}}, "plus")
                    }}
                    className="look-icon look-icon--small look-icon--gray8">
          <AddCircleIcon />
        </IconButton>
        {/*{cItemsAddedToParentCart.includes(cartItem.id) ? (*/}
        {/*  <span className="lm-stock lm-stock--red ll-quantity__in-cart">*/}
        {/*    <FormattedMessage values={{items: cartItem.quantity}} id="look.list.feature.addedToCart"/>*/}
        {/*  </span>*/}
        {/*) : null}*/}
      </div>
    </div>
  )
};

LookWizardSectionListFeatureQuantity.propTypes = {
  lookFeature: PropTypes.shape(featureInterface),
  // featureGroup: PropTypes.object,
  // viewType: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  // wizardGroup: PropTypes.shape(wizardGroupInterface),
}

const mapStateToProps = (store) => {
  const {lookViewType} = store.lookState;
  const {qtActiveCategory} = store.qtState;
  const {cartItems} = store.cartState;

  return {
    lookViewType,
    qtActiveCategory,
    cartItems,
    fabricatorSettings: store.fabricatorState.settings,
  };
};

const mapDispatchToProps = {
  addToCart,
  setWizardSelectedValues,
  changeCartItemQuantity,
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(LookWizardSectionListFeatureQuantity)
)
